import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import BasicInfo from './BasicInfo.js';
import CreatedBy from './CreatedBy.js';
import api from "../../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        nome: '',
        especialidade: '',
        cidade: '',
        telefone1: '',
        telefone2: '',
        celular: '',
        email_principal: '',
        email: '',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [update, setUpdate] = useState(false) // true in edit mode
    useEffect(() => {
        if (props.data) {
            setValues(props.data)
            setUpdate(true)
        }
    }, [props])

    // React.useEffect(() => { checkFields() });

    // function checkFields() {
    //     //aqui testamos o e-mail
    //     let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     let result = re.test(String(values.email).toLowerCase());
    // let dis = true
    // //verificações para habilitar SALVAR
    // if (values.nome !== "" && values.email !== "" && result !== false) {
    //     dis = false
    // }
    // }

    async function AddNew() {
        // snack.current("adicionando, aguarde.", { variant: 'info' })

        var new_consultants = {
            "nome": values.nome,
            "especialidade": values.especialidade,
            "cidade": values.cidade,
            "telefone1": values.telefone1,
            "telefone2": values.telefone2,
            "celular": values.celular,
            "email_principal": values.email_principal,
            "email": values.email,
        }
        api.post(`/contacts/consultants`, { new_consultants })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current(`consultor criado!`, { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar consultor!", { variant: 'error' })
                }
            });
    }

    async function Update() {
        var update_consultants = {
            "_id": values._id,
            "nome": values.nome,
            "especialidade": values.especialidade,
            "cidade": values.cidade,
            "telefone1": values.telefone1,
            "telefone2": values.telefone2,
            "celular": values.celular,
            "email_principal": values.email_principal,
            "email": values.email,
        }
        api.put(`/contacts/consultants`, { update_consultants })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("Consultor editado!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar o consultor!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <BasicInfo values={values} setValues={setValues} update={update} />
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    onClick={() => { update === true ? Update() : AddNew() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
